import React, { useContext, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import JoditEditor from "jodit-react";
import classNames from "classnames";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import "../../Tabels/Tabels.css";

const toMessage = (value, fallback) => {
  if (!value) return fallback;
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value.map((v) => toMessage(v, "")).join(", ");
  return value.message || value.original?.sqlMessage || fallback;
};

const AddIngredient = (props) => {
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const {
    control,
    register,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm({ defaultValues: { name: "", description: "" } });

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data.name.trim());
      formData.append("description", data.description || "");
      const response = await postData("/admin/masters/ingredient", formData);

      setShowModal({
        code: response?.code || (response?.success ? 200 : 400),
        message: response?.success
          ? response.message
          : toMessage(
              response?.errors || response?.message,
              "Unable to add ingredient"
            ),
      });

      if (response?.success) {
        setTimeout(() => {
          setShowModal({ code: 0, message: "" });
          props.handleClose();
        }, 1000);
      }
    } catch (error) {
      console.error("Error adding ingredient:", error);
      setShowModal({ code: 500, message: "Unable to add ingredient" });
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="ingredient-add-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="ingredient-add-title">Add Ingredient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={12}>
                <Form.Group className="main-form-section mt-3">
                  <Form.Label>Name</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Ingredient name"
                      className={classNames({
                        "is-invalid": errors.name,
                      })}
                      {...register("name", {
                        required: "Name is required",
                        maxLength: {
                          value: 200,
                          message: "Name must be 200 characters or less",
                        },
                      })}
                    />
                  </InputGroup>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="main-form-section mt-3">
                  <Form.Label>Description</Form.Label>
                  <Controller
                    name="description"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <JoditEditor
                        value={value}
                        onBlur={() => {
                          onBlur();
                          trigger("description");
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </Form.Group>
              </Col>
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <CancelButton
                    name="cancel"
                    handleClose={props.handleClose}
                  />
                  <SaveButton
                    name="save"
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      <ModalSave
        message={showModal.message}
        showErrorModal={Boolean(showModal.code)}
      />
    </>
  );
};

export default AddIngredient;
